import { useCallback, useSyncExternalStore } from 'react';
import { isEffectivelyLocked, type SceneStore } from '@os/doc';

/** The list's effective lock (itself or a section around it), re-read whenever the board's list changes. */
export function useListLocked(store: SceneStore, id: string): boolean {
  const subscribe = useCallback((cb: () => void) => store.subscribeList(cb), [store]);
  return useSyncExternalStore(subscribe, () => isEffectivelyLocked(store.graph(), (i) => store.getObject(i), id));
}
